export default function initWhitepapersCarousel() {
    // ==========================================================
    // WHITEPAPERS CAROUSEL
    // ==========================================================

    const whitepapersCarousels = document.querySelectorAll("[data-whitepapers-carousel]");

    whitepapersCarousels.forEach((carousel) => {
        const slides = Array.from(carousel.querySelectorAll("[data-whitepapers-slide]"));

        const prevButton = carousel.querySelector("[data-whitepapers-prev]");
        const nextButton = carousel.querySelector("[data-whitepapers-next]");

        if (!slides.length) {
            return;
        }

        let activeIndex = 0;

        const getPreviousIndex = () => {
            return (activeIndex - 1 + slides.length) % slides.length;
        };

        const getNextIndex = () => {
            return (activeIndex + 1) % slides.length;
        };

        const render = () => {
            const previousIndex = getPreviousIndex();
            const nextIndex = getNextIndex();

            slides.forEach((slide, index) => {
                slide.classList.remove("is-active", "is-prev", "is-next", "is-hidden");

                if (index === activeIndex) {
                    slide.classList.add("is-active");
                    return;
                }

                if (index === previousIndex) {
                    slide.classList.add("is-prev");
                    return;
                }

                if (index === nextIndex) {
                    slide.classList.add("is-next");
                    return;
                }

                slide.classList.add("is-hidden");
            });
        };

        const goNext = () => {
            activeIndex = (activeIndex + 1) % slides.length;
            render();
        };

        const goPrev = () => {
            activeIndex = (activeIndex - 1 + slides.length) % slides.length;
            render();
        };

        nextButton?.addEventListener("click", goNext);
        prevButton?.addEventListener("click", goPrev);

        slides.forEach((slide, index) => {
            slide.addEventListener("click", () => {
                if (index === getPreviousIndex()) {
                    goPrev();
                } else if (index === getNextIndex()) {
                    goNext();
                }
            });
        });

        render();
    });
}